import React from 'react';

import { ExtendedWorkspaceListItem } from '@futrli/views/operations/workspaces/processors/workspacesList';
import { ListingPageFilterBar } from '@futrli/ui-components/components/listing-page/listing-page-filter-bar/listing-page-filter-bar';

import { DatasourceFilter } from './components/datasource-filter';
import { StatusFilter } from './components/status-filter';
import { WorkspaceFilter } from './components/workspace-filter';

interface WorkspacesOrganisationsListFilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  workspaceFilterValue: string;
  onWorkspaceFilterChange: (value: string) => void;
  datasourceFilterValue: string;
  onDatasourceFilterChange: (value: string) => void;
  statusFilterValue: string;
  onStatusFilterChange: (value: string) => void;
  stickyTop?: number;
  workspaces?: ExtendedWorkspaceListItem[];
  hideWorkspaceFilter?: boolean;
}

export const WorkspacesOrganisationsListFilterBar = ({
  searchTerm,
  onSearchChange,
  workspaceFilterValue,
  onWorkspaceFilterChange,
  datasourceFilterValue,
  onDatasourceFilterChange,
  statusFilterValue,
  onStatusFilterChange,
  stickyTop,
  workspaces,
  hideWorkspaceFilter = false
}: WorkspacesOrganisationsListFilterBarProps) => {
  return (
    <ListingPageFilterBar searchTerm={searchTerm} onSearchChange={onSearchChange} stickyTop={stickyTop}>
      {!hideWorkspaceFilter && (
        <WorkspaceFilter
          onChange={onWorkspaceFilterChange}
          selectedValue={workspaceFilterValue}
          workspaces={workspaces}
        />
      )}
      <DatasourceFilter
        onChange={onDatasourceFilterChange}
        selectedValue={datasourceFilterValue}
        workspaces={workspaces}
      />
      <StatusFilter onChange={onStatusFilterChange} selectedValue={statusFilterValue} />
    </ListingPageFilterBar>
  );
};
